import React from 'react'

const TOOLS = [
  { name: 'Themes', href: '/themes' },
  { name: 'Font Explorer', href: '/google-font-explorer' },
  { name: 'Font Pairings', href: '/font-pairings' },
  { name: 'Motion', href: '/motion-playground' },
  { name: 'SVG Backgrounds', href: '/svg-backgrounds' },
]

interface ToolNavProps {
  current: string
  action?: React.ReactNode
}

export default function ToolNav({ current, action }: ToolNavProps) {
  return (
    <div className="bg-gray-900 text-gray-300 text-xs">
      <div className="max-w-7xl mx-auto px-4 flex items-center gap-1 h-8">
        <a
          href="/"
          className="mr-2 text-gray-500 hover:text-gray-300 transition-colors font-medium tracking-wide"
        >
          NIMBLE
        </a>
        <span className="text-gray-700 mr-1">/</span>
        {TOOLS.map((tool) => {
          const isActive = current === tool.href
          return (
            <a
              key={tool.href}
              href={tool.href}
              className={`px-2.5 py-1 rounded transition-colors ${
                isActive
                  ? 'text-white bg-gray-700/60'
                  : 'text-gray-400 hover:text-white hover:bg-gray-800'
              }`}
            >
              {tool.name}
            </a>
          )
        })}
        {action && <div className="ml-auto">{action}</div>}
      </div>
    </div>
  )
}
